import { IconLabel, IconLabelProps } from '../IconLabel';
import {
    CallToAction as RawCallToAction,
    CallToActionProps as RawCallToActionProps,
    Checklist,
} from '../../../components/landingPage/CallToAction';
import React from 'react';
import { SanityBlock, SanityObject } from '../../../lib/landingPage';
import { ButtonLink, ButtonLinkProps } from '../Link';
import { VideoProps, Video } from '../Video';
import { ImageProps, Image } from '../Image';
import { Union, Wrapper } from '../Wrapper';
import { PortableText } from '../PortableText';
import { getPoster } from '../../../lib/landingPage/video';

type CallToActionLabelSetProps = {
    labels: SanityObject<IconLabelProps>[];
};

const CallToActionLabelSet = Wrapper(
    ({ labels }: CallToActionLabelSetProps) => {
        return (
            <Checklist>
                <IconLabel value={labels} />
            </Checklist>
        );
    },
    'callToActionLabels'
);

export type CallToActionProps = {
    description: SanityBlock;
    title: string;
    content: SanityObject<VideoProps | CallToActionLabelSetProps | ImageProps>;
    subText: string;
    color: RawCallToActionProps['color'];
    link: SanityObject<ButtonLinkProps>;
};

export const CallToAction = Wrapper(
    ({
        title,
        content,
        link,
        color,
        description,
        subText,
    }: CallToActionProps): JSX.Element => {
        const contentType = (function () {
            if (content._type === 'img') return 'image';
            if (content._type === 'video') return 'video';
            return 'other';
        })();
        const poster =
            content._type === 'video'
                ? getPoster((content as SanityObject<VideoProps>).poster)?.url()
                : undefined;

        return (
            <RawCallToAction
                poster={poster}
                contentType={contentType}
                content={
                    <Union
                        value={{ ...content, poster: undefined }}
                        components={[Image, Video, CallToActionLabelSet]}
                    />
                }
                subText={subText}
                color={color}
                title={title}
                link={<ButtonLink value={link} />}>
                <PortableText value={description} />
            </RawCallToAction>
        );
    },
    'callToAction'
);
